import React, {PropTypes} from 'react';
import BundlingRuleListActiveContainer from './BundlingRuleListActiveContainer.jsx';
import DisplayIf from 'shared/DisplayIf.jsx';

const Bundles = ({
  activeBundlingRuleQty,
  onNewBundlingRuleClick
}) => (
  
  <div className="flex center animated fadeIn">
    <div className="col-xs-12 col-lg-10">
      <div className="panel panel-primary">
        <div className="panel-heading row">
          <div className="col-sm-6">
            <h4 className="panel-title">{'Bundling Rules'}</h4>
          </div> 
          <div className="col-sm-6">
            <div className="text-right">
              <DisplayIf condition={!activeBundlingRuleQty}>
                <button className="btn btn-primary btn-lg"
                  type="button"
                  onClick={onNewBundlingRuleClick}>
                  <i className="fa fa-plus" /> {`New Bundling Rule`}
                </button>
              </DisplayIf>
            </div>
          </div>
        </div>
        <div className="panel-body">
          {activeBundlingRuleQty
            ? <BundlingRuleListActiveContainer />
          : <div className="alert alert-info">{`No active rule to display.`}</div>
          }
        </div>
      </div>
    </div>
  </div>
);

Bundles.propTypes = {
  activeBundlingRuleQty: PropTypes.number,
  onNewBundlingRuleClick: PropTypes.func
};

export default Bundles;



// WEBPACK FOOTER //
// ./src/features/tournament/restrictions/bundles/Bundles.jsx